<template>
  <v-card class="rounded-lg">
    <card-header
      :title="title"
      :icon="icon"
      color="primary"
      variant="gradient"
    ></card-header>
    <v-card-text>
      <v-data-table
        :headers="columns"
        :items="queriedData"
        :items-per-page="pagination.size"
        hide-default-footer
        class="elevation-0 mt-5 pa-1"
        :page="pagination.page"
        @update:page="updatePage"
      >
        <template v-slot:top>
          <v-row align="center" class="mb-2">
            <v-col cols="3">
              <v-select
                v-model="pagination.size"
                :items="perPageOptions"
                label="Per page"
                dense
                outlined
                @change="updateSize"
              ></v-select>
            </v-col>
            <v-col cols="6" class="text-right ml-auto">
              <slot name="top-buttons"></slot>
            </v-col>
          </v-row>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="(column, index) in columns" :key="index">
              <template v-if="column.type === 'text'">
                <div :class="{ 'text-highlight': column.highlighted }">
                  <div
                    v-if="
                      typeof item[column.value] === 'object' &&
                      item[column.value] !== null
                    "
                  >
                    {{ item[column.value][column.subField] }}
                  </div>
                  <div v-else>
                    {{ item[column.value] }}
                  </div>
                </div>
              </template>
              <template v-else-if="column.type === 'chip'">
                <v-chip
                  v-for="chip in item[column.value]"
                  :key="chip"
                  class="ma-1"
                  color="primary"
                  small
                  outlined
                  >{{ chip }}</v-chip
                >
              </template>
              <template v-else-if="column.type === 'button'">
                <custom-button
                  v-for="(action, actionIndex) in column.actions"
                  :key="actionIndex"
                  @click="action.handler(item)"
                  :icon="action.icon"
                  :color="action.color"
                  size="xs"
                  class="ma-1"
                  gradient
                  fab
                ></custom-button>
              </template>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <tr>
            <td :colspan="columns.length" class="text-center">
              No data available.
            </td>
          </tr>
        </template>
      </v-data-table>

      <slot name="bottom-buttons"></slot>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <p class="card-category mt-3">
        Showing {{ from + 1 }} to {{ to }} of
        {{ pagination.total_elements }} entries
      </p>
      <v-spacer></v-spacer>
      <v-pagination
        v-model="pagination.page"
        :length="pagination.total_pages"
        color="accent"
        total-visible="5"
        circle
        @input="updatePage"
      ></v-pagination>
    </v-card-actions>
  </v-card>
</template>

<script>
import CardHeader from "@/components/cards/CardHeader.vue";
import CustomButton from "@/components/common/buttons/CustomButton.vue";

export default {
  components: {
    CardHeader,
    CustomButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    columns: {
      type: Array,
      required: true,
    },
    data: {
      type: Object,
      required: true,
      default: () => ({
        page_info: {
          page: 1,
          size: 5,
          total_elements: 1,
          total_pages: 1,
        },
        elements: [],
      }),
    },
  },
  computed: {
    queriedData() {
      return this.searchedData.length > 0 ? this.searchedData : this.tableData;
    },
    to() {
      return Math.min(
        this.from + this.pagination.size,
        this.pagination.total_elements
      );
    },
    from() {
      return this.pagination.size * (this.pagination.page - 1);
    },
  },
  data() {
    return {
      pagination: this.data.page_info,
      tableData: this.data.elements,
      perPageOptions: [5, 10, 25, 50],
      searchedData: [],
    };
  },
  methods: {
    updatePage(page) {
      this.pagination.page = page;
      this.$emit("updatePagination", this.pagination);
    },
    updateSize(size) {
      this.pagination.size = size;
      this.pagination.page = 1;
      this.$emit("updatePagination", this.pagination);
    },
  },
  // computed: {
  //   headers() {
  //     return this.columns.map(column => ({
  //       text: column.label, // 헤더명
  //       value: column.field, // 데이터 필드 매칭
  //     }));
  //   }
  // }
};
</script>

<style scoped>
.text-highlight {
  font-weight: bold;
  color: #ff9800;
}
</style>
